import { FC, useEffect, useRef } from 'react'

import { useBoolean, useClickAway } from 'ahooks'

import { trueOrUndefined } from '@trustycars/genie-ui/functions'
import { Icon } from '@trustycars/genie-ui/icons'
import { Portal } from '@trustycars/genie-ui/components'

import useNoScrollY from '$browser/useNoScrollY'
import useRouter from '$actions/useRouter'

import { useAuthenticatedLayout } from '../context'
import Menu from '../Menu'
import AccountInfo from '../AccountInfo'
import SidebarActionCard from '../SidebarActionCard'

import {
  aside,
  actions,
  closeButton,
  footer,
  main,
  openButton,
  overlay,
  overlayContent
} from './style.css'

export const MobileSidebarContents: FC = () => {
  const { name } = useRouter()

  const {
    sidebarActions: { hasActions }
  } = useAuthenticatedLayout()

  const contentRef = useRef(null)
  const buttonRef = useRef(null)

  const [open, { setTrue, setFalse }] = useBoolean()

  useNoScrollY('mobile-menu', open)
  useClickAway(setFalse, [contentRef, buttonRef])

  // Close upon route change
  useEffect(() => {
    setFalse()
  }, [name, setFalse])

  return (
    <>
      <Portal>
        <section
          role="dialog"
          aria-hidden={trueOrUndefined(!open)}
          className={overlay({ open })}
        >
          <article ref={contentRef} className={overlayContent}>
            <aside className={aside}>
              <AccountInfo />
            </aside>

            <main className={main}>
              <Menu />
            </main>

            {hasActions && (
              <div className={actions}>
                <SidebarActionCard />
              </div>
            )}

            <footer className={footer}>
              <button
                onClick={setFalse}
                className={closeButton}
                type="button"
                title="Close"
              >
                <Icon namespace="Cross" />
              </button>
            </footer>
          </article>
        </section>
      </Portal>

      <button
        ref={buttonRef}
        onClick={setTrue}
        className={openButton}
        type="button"
        title="Open Menu"
      >
        <Icon namespace="Menu" />
      </button>
    </>
  )
}

export default MobileSidebarContents
